import React, { useContext } from "react";

import { Container } from "mondrian-react";
import Header from "components/Header";
import Footer from "components/Footer";
import LeftMenu from "components/LeftMenu";
import { store } from "store";
import UserInfo from "../UserInfo";
import InternalLink from "components/InternalLink";

export default function Page(props) {
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { accesstoken } = state;

  return (
    <>
      <UserInfo>
        <div className="cred-main">
          <Header>
            <div className="mdn-u-padding--sm mdn-Topic--horizontal mdn-Topic--sm">
              <div className="mdn-Container">
                <div className="mdn-u-paddingTop--xxs">
                  <InternalLink
                    className="cred-card mdn-Heading"
                    link="/meuperfil"
                    data-gtm-event-category="minha-claro:meu-perfil"
                    data-gtm-event-action="clique:link"
                    data-gtm-event-label="meu-perfil"
                    tabIndex={-1}
                  >
                    <p className="mdn-Topic-description">Meu Perfil</p>
                  </InternalLink>
                </div>
              </div>
            </div>
          </Header>
          <div className="cred-main-content" id="main-content">
            <Container>
              <div className="mdn-Row">
                <div className="mdn-Col-md-3 mdn-u-border-right cred-left-menu">
                  <LeftMenu />
                </div>
                <div className="mdn-Col-xs-12 mdn-Col-sm-12 mdn-Col-md-9">
                  <div className="formBox">
                    <div className="innerBox">{props.children}</div>
                  </div>
                </div>
              </div>
            </Container>
          </div>
          <Footer />
        </div>
      </UserInfo>
    </>
  );
}
